import "./GeneralSettings.scss"
import React, { FC, useEffect } from "react"
import { FormControlLabel, Switch, Typography } from "@mui/material"
import {
  Checkbox,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import {
  getUserAsync,
  selectUserData,
  updateUserAsync,
  updateUserSettingsAsync,
} from "../../../redux/slices/authSlice"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import { UserData } from "../../../types/userTypes"
import { useState } from "react"
import { LANGUAGE_KEYS } from "../../../config/language.const"
import { use } from "i18next"
const GeneralSettings: FC = () => {
  const [selectedLanguage, setSelectedLanguage] = useState<number | undefined>(0)

  const dispatch = useAppDispatch()
  const {
    GENERAL_DETAILS_TITLE,
    GENERAL_TOGGLE_1,
    GENERAL_TOGGLE_2,
    GENERAL_TOGGLE_3,
  } = useTranslationLabel()
  const userData: UserData | null = useAppSelector(selectUserData)

  const receiptsViaEmail = userData?.accountDetails?.mailNotificationReceipt;
  const mailNotificationAdvertisement = userData?.notification.mailNotificationAdvertisement;
  const language = userData?.settings.languageId;

  useEffect(() => {
    setSelectedLanguage(language);
  },[]);

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    let updateUser;
    if (event.target.name === "receiptsViaEmail") {
      updateUser = {
        accountDetails: {
          mailNotificationReceipt: event.target.checked,
        },
      }
    }
    if (event.target.name === "mailNotificationAdvertisement") {
      updateUser = {
        notification: {
          mailNotificationAdvertisement: event.target.checked,
          notificationViaSMS: event.target.checked,
        },
      }
    }
    if (event.target.name === "language") {
      setSelectedLanguage(Number(event.target.value));
      updateUser = {
        settings: {
          languageId: event.target.value,
        },
      }
    }

    await dispatch(updateUserSettingsAsync(updateUser))
      .unwrap()
      .then(() => {
        dispatch(getUserAsync())
      })
      .catch((err) => {
        alert("Something went wrong!")
      })
  }

  if (!userData) return null
  
  return (
    <div className="general-settings-container">
      <Typography variant="h4" className="general-settings-title">
        {GENERAL_DETAILS_TITLE}
      </Typography>
      {receiptsViaEmail !== undefined && <FormControlLabel
        control={
          <Switch
            checked={receiptsViaEmail}
            onChange={handleChange}
            name="receiptsViaEmail"
            color="primary"
          />
        }
        label={<Typography variant="body1">{GENERAL_TOGGLE_1}</Typography>}
        labelPlacement="start"
        className="general-settings-option"
      />}
      <FormControlLabel
        control={
          <Switch
            checked={mailNotificationAdvertisement}
            onChange={handleChange}
            name="mailNotificationAdvertisement"
            color="primary"
          />
        }
        label={<Typography variant="body1">{GENERAL_TOGGLE_2}</Typography>}
        labelPlacement="start"
        className="general-settings-option"
      />
      <FormControlLabel
        control={
          <RadioGroup
            aria-label="language"
            name="language"
            value={selectedLanguage}
            onChange={handleChange}
            sx={{ flexDirection: "row" }}
          >{LANGUAGE_KEYS.map((language) => <FormControlLabel key={language.value} value={language.value} control={<Radio />} label={language.label} />)}
          </RadioGroup>
        }
        label={<Typography variant="body1">{GENERAL_TOGGLE_3}</Typography>}
        labelPlacement="start"
        className="general-settings-option"
      />
    </div>
  )
}

export default GeneralSettings
